import { useLazyQuery } from '@apollo/client'

import { GetInvoiceItemSettings as GetInvoiceItemSettingsResponse } from 'types/gql-types/GetInvoiceItemSettings'

import { GetInvoiceItemSettings } from './graphql/getInvoiceItemSettings'

export const useGetInvoiceItemSettings = () => {
  const [getInvoiceItemSettings, { data, loading: isLoading }] =
    useLazyQuery<GetInvoiceItemSettingsResponse>(GetInvoiceItemSettings)

  const settings = data?.getItemSettings

  return {
    getInvoiceItemSettings,
    isLoading,
    settings,
  }
}
